import { createBrowserRouter } from 'react-router-dom';
import MainLayout from './components/Layout/MainLayout';
import AdminLayout from './components/Admin/AdminLayout';
import AdminDashboard from './components/Admin/AdminDashboard';
import NotificationsManager from './components/Admin/NotificationsManager';
import UserList from './components/Admin/UserList';
import ReconstructionWebhooks from './components/Admin/ReconstructionWebhooks';
import ServerLogs from './components/Admin/ServerLogs';
import WhosOnline from './components/Admin/WhosOnline';
import PhiDetectionSettings from './components/Admin/PhiDetectionSettings';
import Feed from './components/Feed/Feed';
import SearchResults from './components/Feed/SearchResults';
import MyPostsSection from './components/Feed/MyPostsSection';
import SavedPostsSection from './components/Feed/SavedPostsSection';
import DraftsPage from './components/Draft/DraftsPage';
import ProfilePage from './components/Profile/ProfilePage';
import EditProfile from './components/Profile/EditProfile';
import Settings from './components/Settings/Settings';
import JointSpecialty from './components/Settings/JointSpecialty';
import NotificationSettings from './components/Settings/NotificationSettings';
import HelpSupport from './components/Settings/HelpSupport';
import AppInformation from './components/Settings/AppInformation';
import AnalyticsPage from './components/Analytics/AnalyticsPage';
import AuthCallback from './components/Auth/AuthCallback';
import GPSCallback from './components/Auth/GPSCallback';
import SilentCallback from './components/Auth/SilentCallback';

export const router = createBrowserRouter([
  {
    path: '/auth/callback',
    element: <AuthCallback />,
  },
  {
    path: '/auth/legacy-callback',
    element: <AuthCallback />,
  },
  {
    path: '/auth/gps-callback',
    element: <GPSCallback />,
  },
  {
    path: '/auth/silent-callback',
    element: <SilentCallback />,
  },
  {
    path: '/',
    element: <MainLayout />,
    children: [
      {
        index: true,
        element: <Feed />,
      },
      {
        path: 'search',
        element: <SearchResults />,
      },
      {
        path: 'my-posts',
        element: <MyPostsSection />,
      },
      {
        path: 'saved-posts',
        element: <SavedPostsSection />,
      },
      {
        path: 'drafts',
        element: <DraftsPage />,
      },
      {
        path: 'profile',
        element: <ProfilePage />,
      },
      {
        path: 'profile/edit',
        element: <EditProfile />,
      },
      {
        path: 'settings',
        element: <Settings />,
      },
      {
        path: 'settings/joint-specialty',
        element: <JointSpecialty />,
      },
      {
        path: 'settings/notifications',
        element: <NotificationSettings />,
      },
      {
        path: 'settings/help-support',
        element: <HelpSupport />,
      },
      {
        path: 'settings/app-information',
        element: <AppInformation />,
      },
      {
        path: 'analytics',
        element: <AnalyticsPage />,
      },
    ],
  },
  {
    path: '/admin',
    element: <AdminLayout />,
    children: [
      {
        index: true,
        element: <AdminDashboard />,
      },
      {
        path: 'notifications',
        element: <NotificationsManager />,
      },
      {
        path: 'users',
        element: <UserList />,
      },
      {
        path: 'online',
        element: <WhosOnline />,
      },
      {
        path: 'reconstruction-webhook',
        element: <ReconstructionWebhooks />,
      },
      {
        path: 'logs',
        element: <ServerLogs />,
      },
      {
        path: 'phi-settings',
        element: <PhiDetectionSettings />,
      },
    ],
  },
]);